import React, { useContext } from "react";
import case1 from "../../assets/images/softsidelogo.svg";
import case2 from "../../assets/images/aeslogo.svg";
import case3 from "../../assets/images/tanksandcoverslogo.svg";
import case4 from "../../assets/images/ggplogo.svg";
import PrimaryButton from "../common/PrimaryButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { Link } from "react-router-dom";
import Data from "./Data";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowRightLong } from "react-icons/fa6";

type CaseType = {
  img: string;
  des: string;
  path: string;
};

const cases: CaseType[] = [
  {
    img: case1,
    des: "Explore how we redefined Softside’s presence with a stronger website, cohesive content, and targeted outreach that positioned the product as a premium essential.",
    path: "/case-study/softside",
  },
  {
    img: case2,
    des: "See how we transformed AES’s website and branding to match the credibility and sharp positioning expected from an executive recruitment leader.",
    path: "/case-study/aes",
  },
  {
    img: case3,
    des: "Learn how we helped TanksandCovers stand out in a technical niche using custom messaging, clean design and focused brand positioning that drives meaningful engagement.",
    path: "/case-study/tanksandcover",
  },
  {
    img: case4,
    des: "Discover how we helped Get Growth Partners elevate its digital presence by designing a high-converting website and a clear, confident brand that speaks to serious business owners.",
    path: "/case-study/ggp",
  },
];

const Cases = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-primary" : "bg-[#141414]"
      } transition-all duration-500`}
    >
      <div className="lg:px-20 max-w-screen-2xl mx-auto py-8 lg:py-28">
        <Swiper
          spaceBetween={10}
          slidesPerView={3}
          modules={[Navigation, Autoplay]}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay
          loop={true}
        >
          {cases.map((item, index) => (
            <SwiperSlide className="h-full">
              <div
                className={`${
                  theme === "dark" ? "bg-white" : "card-gradient"
                } p-[1px] rounded-[16px] hover:shadow-[0px_0px_30px_#f20b97] transition-all duration-500 h-[500px] sm:h-[450px] m-5`}
              >
                <div
                  className={`${
                    theme === "dark"
                      ? "bg-primary"
                      : "bg-[#141414] hover:shadow-[inset_0px_0px_30px_#8d19da]"
                  } py-12 px-10 rounded-[16px] flex flex-col justify-between items-center sm:items-start transition-all duration-500 h-full `}
                  key={index}
                >
                  <img src={item.img} alt="" className="h-28 mb-10" />
                  <p className="text-white mb-10 text-center sm:text-start">{item.des}</p>
                  <Link to={item.path}>
                    <PrimaryButton className=" relative !bg-white !text-secondary z-10 hover:!bg-secondary hover:!text-white transition-all duration-500">
                      View Case Study
                    </PrimaryButton>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="flex items-center justify-center mt-5 sm:mt-10">
          <div className="flex my-auto gap-2">
            <div className="swiper-button-prev p-4 bg-secondary  [&>*]:hover:text-black transition-custom rounded-full relative z-10 cursor-pointer">
              <FaArrowRightLong className="text-white rotate-180" />
            </div>
            <div className="swiper-button-next p-4 bg-secondary [&>*]:hover:text-black transition-custom rounded-full relative z-10 cursor-pointer">
              <FaArrowRightLong className="text-white" />
            </div>
          </div>
        </div>
      </div>
      <Data />
    </div>
  );
};

export default Cases;
